var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info box"},[(_vm.viewForm)?_c('form-element',{attrs:{"el-conf":_vm.baseFormConf,"show-cancel-btn":true,"confirmBtnLabel":"确定"},on:{"onCancel":_vm.onCancel,"onSubmit":_vm.saveUserInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }